/**
 * ЭТАП 1 · Шаг 3 — СЕРВЕРНЫЙ шим глобального `location`.
 *
 * Легаси-компоненты (~40 файлов, 100+ обращений) читают bare
 * `location.pathname/hash/search/origin/href` прямо в рендере. На сервере
 * глобального `location` нет → "location is not defined" на каждой такой странице.
 *
 * Здесь определяем globalThis.location ТОЛЬКО НА СЕРВЕРЕ как геттер поверх
 * legacyHistory.location — того же источника, что useLocation/useHistory
 * (проверено: они возвращают ровно legacyHistory.location, см. compat/router.tsx).
 * legacyHistory привязан к роутеру ТЕКУЩЕГО запроса в getRouter(), поэтому путь
 * корректный per-request. Так весь класс bare-`location` чинится разом, без правки
 * каждого файла (это compat-мост, как сам legacyHistory; целевой уход —
 * useLocation/useNavigate — отдельным техдолгом).
 *
 * Клиент НЕ трогаем: там настоящий window.location (шим не ставится).
 * Мутации (reload/assign/replace) на сервере — no-op. origin захардкожен на
 * прод-домен (для абсолютных SEO-URL в SSR; на dev-клиенте origin отличается —
 * возможен hydration-mismatch только для origin-производных строк, некритично).
 *
 * ВАЖНО: импортировать ПЕРВЫМ в __root.tsx, до остальных модулей.
 */
import { legacyHistory } from '../routing/legacyHistory';

if (
  typeof window === 'undefined' &&
  typeof (globalThis as { location?: unknown }).location === 'undefined'
) {
  const ORIGIN = 'https://www.delikateska.ru';
  Object.defineProperty(globalThis, 'location', {
    configurable: true,
    // no-op сеттер: на сервере встречаются присваивания вида
    // `window.location = url` / `location.href = url` (после кодмода → `location = ...`).
    // Без сеттера strict-mode бросил бы "Cannot set property location". Навигация
    // на сервере не нужна — глотаем.
    set() {},
    get() {
      let pathname = '/';
      let search = '';
      let hash = '';
      try {
        const loc = legacyHistory.location;
        pathname = loc?.pathname || '/';
        search = loc?.search || '';
        hash = loc?.hash || '';
      } catch {
        // роутер ещё не привязан (module-eval до getRouter) — дефолт '/'
      }
      const href = ORIGIN + pathname + search + hash;
      return {
        origin: ORIGIN,
        protocol: 'https:',
        host: 'www.delikateska.ru',
        hostname: 'www.delikateska.ru',
        port: '',
        pathname,
        search,
        hash,
        href,
        reload() {},
        assign() {},
        replace() {},
        toString() {
          return href;
        }
      };
    }
  });
}
